import type { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const styles = {
  shoppingCart: (theme: Theme) => ({
    width: '8rem',
    justifyContent: 'center',
    position: 'relative',
    backgroundColor: theme.colors.primary[500],
    color: theme.colors.white,
  }),

  counterWrapper: {
    position: 'absolute',
    top: '-0.75rem',
    width: '100%',
  },

  counter: (theme: Theme) => ({
    backgroundColor: theme.colors.white,
    color: theme.colors.primary[500],
    py: 0.5,
    px: 1,
    borderRadius: '0.25rem',
    fontSize: 14,
    boxShadow: `0 4px 18px ${alpha(theme.colors.black, 0.1)}`,
    zIndex: 1,
  }),
};
